import type BusinessRule from '~/types/BusinessRule';

import { type ActionTypes } from '~/actions';
import { ActionKeys } from '~/actions/constants';
import { EMPTY_RULE_ERROR, type AutomationRuleError } from '~/types/AutomationRuleError';

export type AutomationsState = {
  readonly addRuleModalIsOpen: boolean;
  readonly addRuleSuccess: boolean;
  readonly associatedPackageTemplateIds: string[];
  readonly businessRules: BusinessRule[];
  readonly closedReprocessingCompleteNotification: boolean;
  readonly closedReprocessingPendingNotification: boolean;
  readonly deleteRuleModalIsOpen: boolean;
  readonly error: AutomationRuleError;
  readonly reprocessRuleStatus: string;
};

const initialState: AutomationsState = {
  addRuleModalIsOpen: false,
  addRuleSuccess: false,
  associatedPackageTemplateIds: [],
  businessRules: [],
  closedReprocessingCompleteNotification: false,
  closedReprocessingPendingNotification: false,
  deleteRuleModalIsOpen: false,
  error: EMPTY_RULE_ERROR,
  reprocessRuleStatus: '',
};

const automationsReducer = (
  state: AutomationsState = initialState,
  action: ActionTypes,
): AutomationsState => {
  switch (action.type) {
    case ActionKeys.FETCH_BUSINESS_RULES_SUCCESS:
      return {
        ...state,
        associatedPackageTemplateIds: action.payload.associatedPackageTemplateIds,
        businessRules: action.payload.businessRules,
      };
    case ActionKeys.AUTOMATIONS_OPEN_DELETE_MODAL:
      return {
        ...state,
        deleteRuleModalIsOpen: true,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_DELETE_MODAL:
      return {
        ...state,
        deleteRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_DELETE_RULE_SUCCESS:
      return {
        ...state,
        deleteRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_DELETE_RULE_ERROR:
      return {
        ...state,
        deleteRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_OPEN_ADD_RULE_MODAL:
      return {
        ...state,
        addRuleModalIsOpen: true,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_ADD_RULE_MODAL:
      return {
        ...state,
        addRuleModalIsOpen: false,
      };
    case ActionKeys.AUTOMATIONS_CREATE_RULE:
      return {
        ...state,
        addRuleSuccess: false,
      };
    case ActionKeys.AUTOMATIONS_CREATE_RULE_SUCCESS:
      return {
        ...state,
        addRuleSuccess: true,
      };
    case ActionKeys.AUTOMATIONS_SET_RULE_ERROR:
      return {
        ...state,
        addRuleSuccess: false,
        error: action.payload.error,
      };
    case ActionKeys.AUTOMATIONS_REORDER_RULES_SUCCESS:
      return {
        ...state,
        businessRules: action.payload.rules,
      };
    case ActionKeys.AUTOMATIONS_UPDATE_REPROCESS_STATUS:
      return {
        ...state,
        reprocessRuleStatus: action.payload.status,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_RULE_REPROCESS_PENDING_NOTIF:
      return {
        ...state,
        closedReprocessingPendingNotification: true,
      };
    case ActionKeys.AUTOMATIONS_CLOSE_RULE_REPROCESS_COMPLETE_NOTIF:
      return {
        ...state,
        closedReprocessingCompleteNotification: true,
      };
    case ActionKeys.AUTOMATIONS_RESET_RULE_REPROCESS_PENDING_NOTIF:
      return {
        ...state,
        closedReprocessingPendingNotification: false,
      };
    case ActionKeys.AUTOMATIONS_RESET_RULE_REPROCESS_COMPLETE_NOTIF:
      return {
        ...state,
        closedReprocessingCompleteNotification: false,
      };
    default:
      return state;
  }
};

export default automationsReducer;
